export default "__VITE_ASSET__8b09df0b__"